import React from 'react';
import { useTranslation } from 'react-i18next';

import { CheckSvg, CloseSvg, GuaranteeSvg, InfoCircleSvg, WarningSvg } from '../../svg';

import * as S from './SwitchElements';

interface IProps {
  className?: string;
  title: string;
  isActive: boolean;
  isOption?: boolean;
  isSmall?: boolean;
  color?: string;
  severityText?: string;
  is_guaranteed?: boolean | undefined;
  onChange: (v: boolean) => void;
}

const icon = (color?: string) => {
  switch (color) {
    case 'Red':
      return <CloseSvg />;
    case 'Orange':
      return <WarningSvg />;
    case 'Gray':
      return <InfoCircleSvg />;
    default:
      return <CheckSvg />;
  }
};

export const Switch: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  return (
    <S.Container className={props.className}>
      <S.TitleWrapper>
        {props.is_guaranteed !== undefined && (
          <GuaranteeSvg
            className={`tw-w-[16px] tw-mr-2 ${
              (!props.is_guaranteed && 'tw-grayscale tw-opacity-50') || ''
            }`}
          />
        )}
        <S.Label className="switch">{props.title}</S.Label>
      </S.TitleWrapper>
      {!props.isOption && <S.Line />}
      <S.RowWrapper>
        {props.isOption && (
          <S.LabelOption className="switch">{t('car_inspection.option')}</S.LabelOption>
        )}
        <S.Switch $isSmall={props.isSmall} $color={props.color} $isActive={props.isActive}>
          <input
            className={'tw-hidden'}
            type={'checkbox'}
            checked={props.isActive}
            onChange={(e) => props.onChange(e.target.checked)}
          />
          <span className="slider round">
            <span className="switch">{icon(props.severityText)}</span>
          </span>
        </S.Switch>
      </S.RowWrapper>
    </S.Container>
  );
};
